<template>
  <div>
    <b-alert
      :show="dismissCountDown"
      dismissible
      fade
      variant="primary"
      @dismiss-count-down="countDownChanged"
    >
      {{allertMessage}}
  </b-alert>
   <modal :show.sync="createJobModal"
          @close="closeCustomJobFormModal"
          class="customJobFormModal">
     <preloader v-if="showPreloader"></preloader>
     <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Please fill at least one from 3 field about job and choose job type</h5>
     </template>
     <template>
      <form v-if="form" role="form" @submit.prevent ref="form">
        <base-input alternative
                    class="mb-3"
                    name="customJobId"
                    placeholder="Job ID"
                    :error="vErrors.first('customJobId')"
                    v-model="customJobId">
        </base-input>
        <base-input alternative
                    class="mb-3"
                    name="customJobLocationId"
                    placeholder="Location ID"
                    :error="vErrors.first('customJobLocationId')"
                    v-model="customJobLocationId">
        </base-input>
        <base-input alternative
                    class="mb-3"
                    name="customJobNameAdress"
                    placeholder="Name/Adress"
                    v-validate ="{ rules: { required: customJobLocationId || customJobId?false:true} }"
                    :error="vErrors.first('customJobNameAdress')"
                    v-model="customJobNameAdress">
        </base-input>
        <div class="form-group mb-3 input-group-alternative">
          <b-form-select
                multiple
                style="height:11rem;"
                name="customJobAction"
                v-model="customJobAction"
                id="cleanedStand"
                v-validate="'required'"
                data-vv-validate-on="blur">
                <option value="" disabled>Please choose job type</option>
                <option value="1">Stand Service</option>
                <option value="2">Digital</option>
                <option value="4">Delivery</option>
                <option value="8">Digital Header</option>
                <option value="9">Digital Header Troubleshooting</option>
              </b-form-select>
              <div v-if="vErrors.has('customJobAction')"
                    class="text-danger invalid-feedback" style="display: block;">
                    {{ vErrors.first('customJobAction') }}
                </div>
        </div>
        <!-- <b-form-select v-model="selected" placeholder="Loc ID" :options="options"></b-form-select> -->
        <div class="text-center">
            <base-button type="primary" @click="createCustomJob" class="my-4">Create</base-button>
        </div>
      </form>
      <b-list-group>
        <b-list-group-item v-if="checkIfServieFormIsSelected('1')" class="sm">
          <base-button type="primary" size="sm" @click="showHideServiceForm('standService')" class="mb-1" icon="ni ni-bold-down"></base-button>
          <base-button type="primary" size="sm" @click="removeCustomFormFromList('1')" class="mb-1 pull-right" icon="ni ni-fat-remove"></base-button>
          <strong>Stand Service Form</strong>
          <standServiceForm
            :disableSubmitButton="disableButton"
            v-if="standService"
            @standServiceFormDataSend="standServiceSend"></standServiceForm>
        </b-list-group-item>
        <b-list-group-item v-if="checkIfServieFormIsSelected('2')" class="sm">
          <base-button type="primary" size="sm" @click="showHideServiceForm('eboardService')" class="mb-1" icon="ni ni-bold-down"></base-button>
          <base-button type="primary" size="sm" @click="removeCustomFormFromList('2')" class="mb-1 pull-right" icon="ni ni-fat-remove"></base-button>
          <strong>Eboard Service Form</strong>
          <eboardServiceForm
            :disableSubmitButton="disableButton"
            v-if="eboardService"
            @eboardServiceFormDataSend="eboardServiceSend"></eboardServiceForm>
        </b-list-group-item>
        <b-list-group-item v-if="checkIfServieFormIsSelected('4')" class="sm">
          <base-button type="primary" size="sm" @click="showHideServiceForm('delivery')" class="mb-1" icon="ni ni-bold-down"></base-button>
          <base-button type="primary" size="sm" @click="removeCustomFormFromList('4')" class="mb-1 pull-right" icon="ni ni-fat-remove"></base-button>
          <strong>Delivery Form</strong>
          <deliveryForm
            :disableSubmitButton="disableButton"
            v-if="delivery"
            @deliveryInfoFormDataSend="deliveryInfoSend"></deliveryForm>
        </b-list-group-item>
        <b-list-group-item v-if="checkIfServieFormIsSelected('8')" class="sm">
          <base-button type="primary" size="sm" @click="showHideServiceForm('digitalHeader')" class="mb-1" icon="ni ni-bold-down"></base-button>
          <base-button type="primary" size="sm" @click="removeCustomFormFromList('8')" class="mb-1 pull-right" icon="ni ni-fat-remove"></base-button>
          <strong>Digital Header Service Form</strong>
          <digitalHeaderServiceForm
            :disableSubmitButton="disableButton"
            v-if="digitalHeader"
            @digitalHeaderServiceFormDataSend="digitalHeaderServiceSendData"></digitalHeaderServiceForm>
        </b-list-group-item>
        <b-list-group-item v-if="checkIfServieFormIsSelected('9')" class="sm">
          <base-button type="primary" size="sm" @click="showHideServiceForm('digitalHeaderTroubleshoot')" class="mb-1" icon="ni ni-bold-down"></base-button>
          <base-button type="primary" size="sm" @click="removeCustomFormFromList('9')" class="mb-1 pull-right" icon="ni ni-fat-remove"></base-button>
          <strong>Digital Header Troubleshooting Form</strong>
          <digitalHeaderTroubleshootForm
            :disableSubmitButton="disableButton"
            v-if="digitalHeaderTroubleshoot"
            @digitalHeaderTroubleshootFormDataSend="digitalHeaderTroubleshootSendData"></digitalHeaderTroubleshootForm>
        </b-list-group-item>
      </b-list-group>
     </template>
   </modal>
    <div v-if="jobs" class="container">
      <h1 class="text-center"><base-button v-on:click="goHome" class="mt-1 back-button" size="md" type="primary">Back</base-button>
        {{routeSheetName}}
      </h1>
      <div class="mb-3 text-right">
        <base-button size="sm" class="custom-size" @click="openCreateJobModal" type="primary">Create job</base-button>
      </div>
      <div class="card card-profile shadow mb-1" v-for="job in jobs" :key="job.id">
            <div class="card-body text-right sm">
              <b-list-group>
                <b-list-group-item  v-if="isCurrentJobActive(job.id)" class="sm text-center">
                  <strong>Is active now</strong>
                </b-list-group-item>
                <b-list-group-item  v-if="isCurrentJobFinished(job.id)" class="sm text-center">
                  <strong>Complete</strong>
                </b-list-group-item>
                <b-list-group-item class="sm">
                  <span class="pull-left mb-1 block">{{job.id}}</span>
                  <strong class="pull-left clear mb-1 block">{{job.locationName}}</strong>
                  <span class="pull-left clear mb-1 block">{{job.address}}</span>
                  <base-button size="sm" class="custom-size" v-on:click="goToJob(job.id)" type="primary">Details</base-button>
                </b-list-group-item>
                <b-list-group-item class="sm" v-if="job.note">
                  <span class="pull-left">
                    Note:
                    {{job.note}}
                  </span>
                </b-list-group-item>
                <b-list-group-item class="sm" v-if="isCurrentJobActive(job.id)">
                  <strong class="pull-left">Started at</strong>
                  {{activeJob.startTime | moment("h:mm, dd, MM YY")}}
                </b-list-group-item>
              </b-list-group>
            </div>
      </div>
      <div v-if="jobs.length === 0" class="text-center mt-4">
        <h2>There are no Jobs for today</h2>
      </div>
    </div>
  </div>
</template>
<script>
import jobsMixin from './../mixins/jobsMixin'
import jobActionFormMixin from './../mixins/jobActionFormMixin'
import timestampMixin from './../mixins/timestampMixin'
import Modal from '@/components/Modal'
import standServiceForm from './../../components/StandServiceForm'
import eboardServiceForm from './../../components/EboardServiceForm'
import digitalHeaderServiceForm from './../../components/DigitalHeaderServiceForm'
import digitalHeaderTroubleshootForm from './../../components/DigitalHeaderTroubleshootForm'
import deliveryForm from './../../components/DeliveryForm'
import alertMixin from './../mixins/alertMixin'
export default {
  data () {
    return {
      createJobModal: false,
      showPreloader: false,
      customJobId: null,
      customJobLocationId: null,
      customJobNameAdress: null,
      form: true,
      customJobAction: [],
      jobActionsList: [],
      standService: false,
      eboardService: false,
      digitalHeader: false,
      digitalHeaderTroubleshoot: false,
      delivery: false
    }
  },
  computed: {
    jobs () {
      return this.$store.state.driverJobs
    },
    routeSheetName () {
      let name = this.$store.state.currentSheetName
      return name || ''
    },
    token () {
      return this.$store.state.user.token
    }
  },
  methods: {
    // Creating custom job from tablet
    createCustomJob () {
      let self = this
      this.$validator.validateAll({
        customJobId: self.customJobId,
        customJobLocationId: self.customJobLocationId,
        customJobNameAdress: self.customJobNameAdress,
        customJobAction: self.customJobAction
      }).then(function (result) {
        if (result) {
          let customJobObjectData = {
            jobId: self.customJobId,
            locationId: self.customJobLocationId,
            nameAdress: self.customJobNameAdress,
            jobActionType: self.customJobAction
          }
          // self.closeModal()
          self.$store.commit('createJobFromTabled', customJobObjectData)
          self.$store.commit('setCurrentStand', 0)
          self.jobActionsList = self.customJobAction
          self.formReset()
          self.form = false
        }
      })
    },
    openCreateJobModal () {
      this.createJobModal = true
    },
    goToJob (id) {
      this.$store.commit('setCurrentJob', id)
      this.$router.push({ name: 'job', params: { id: id } })
    },
    goHome () {
      this.$router.push('/')
    },
    formReset () {
      this.customJobId = this.customJobLocationId = this.customJobNameAdress = null
      this.customJobAction = []
    },
    closeModal () {
      this.createJobModal = false
      // Need to add this because watcher in modal component can not remove class from body because of redirect
      let documentClasses = document.body.classList
      documentClasses.remove('modal-open')
    },
    close () {
      this.$validator.reset()
    },
    showHideServiceForm (form) {
      this[form] = !this[form]
    },
    checkIfServieFormIsSelected (id) {
      return this.jobActionsList.indexOf(id) > -1
    },
    standServiceSend (data) {
      data.isCreatedFromTablet = true
      this.standServiceSendData(data)
      this.removeCustomFormFromList('1')
    },
    eboardServiceSend (data) {
      data.isCreatedFromTablet = true
      this.eboardServiceSendData(data)
      this.removeCustomFormFromList('2')
    },
    deliveryInfoSend (data) {
      data.isCreatedFromTablet = true
      this.deliveryInfoSendData(data)
      this.removeCustomFormFromList('4')
    },
    closeCustomJobFormModal () {
      this.$store.commit('resetJobCreatedFromTabled')
      this.customJobId = this.customJobLocationId = this.customJobNameAdress = null
      this.customJobAction = this.jobActionsList = []
      this.form = true
    },
    removeCustomFormFromList (index) {
      let position = this.jobActionsList.indexOf(index)
      this.jobActionsList.splice(position, 1)
    }
  },
  components: {
    Modal,
    standServiceForm,
    eboardServiceForm,
    deliveryForm,
    digitalHeaderServiceForm,
    digitalHeaderTroubleshootForm
  },
  mixins: [jobsMixin, jobActionFormMixin, timestampMixin, alertMixin]
}
</script>
<style scoped>
  h1 {
    font-size: 1.2rem;
    padding: 1rem 0;
  }
  .jobs {
    margin-bottom: 10px;
  }
  .job-description {
    text-align: right;
  }
  .job-description span {
    display: block
  }
  .navbar.mb-4 {
    margin-bottom: 0.5rem!important;
  }
  .clear {
    clear: both;
  }
  .block {
    display: inline-block;
  }
  .custom-size {
    padding: 0.35rem 2rem;
  }
  #cleanedStand {
    height:9rem;
  }
</style>
